import axios from "axios";
import React, { useState, useRef } from "react";

const AutoSuggestionInput = ({ text, setText, disabled }) => {
  const [suggestion, setSuggestion] = useState("");
  const [typedWord, setTypedWord] = useState("");
  const [cursorPosition, setCursorPosition] = useState({ top: 0, left: 0 });
  const [error, setError] = useState(null);
  const divRef = useRef(null);

  const getSuggestion = async (wc) => {
    try {
      const res = await axios.get(`/api/random-suggestion/${wc}`);
      if (res.data.status === 200) {
        const randomSuggestion = res?.data?.data;
        setSuggestion(randomSuggestion.startsWith(wc) ? randomSuggestion.slice(wc.length) : "");
        setTypedWord(wc);
        setError(null);
      } else {
        setSuggestion("");
        setTypedWord("");
        setError("Failed to fetch suggestion.");
      }
    } catch (err) {
      setSuggestion("");
      setTypedWord("");
      setError("An error occurred while fetching the suggestion.");
      console.error("Error fetching suggestion:", err);
    }
  };

  const handleInput = () => {
    try {
      const currentText = divRef.current.innerText;
      setText(currentText);

      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        const divRect = divRef.current.getBoundingClientRect();

        setCursorPosition({
          top: rect.top - divRect.top,
          left: rect.left - divRect.left,
        });

        const cursorIsAtEnd = range.endOffset === currentText.length;

        if (cursorIsAtEnd) {
          const trimmedText = currentText.trimEnd();
          const words = trimmedText.split(" ");
          const lastWord = words[words.length - 1];

          if (lastWord) {
            getSuggestion(lastWord);
          } else {
            setSuggestion("");
            setTypedWord("");
          }
        } else {
          setSuggestion("");
          setTypedWord("");
        }
      }
    } catch (err) {
      setError("An error occurred while handling input.");
      console.error("Error handling input:", err);
    }
  };

  const applySuggestion = () => {
    try {
      if (suggestion) {
        const words = text.split(" ");
        words[words.length - 1] = typedWord + suggestion;
        const newText = words.join(" ");
        setText(newText);
        setSuggestion("");
        setTypedWord("");
        divRef.current.innerText = newText;

        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(divRef.current);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    } catch (err) {
      setError("An error occurred while applying the suggestion.");
      console.error("Error applying suggestion:", err);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={divRef}
        contentEditable={!disabled}
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
          width: "300px",
          fontSize: "16px",
          outline: "none",
          overflow: "auto",
          direction: "ltr",
          textAlign: "left",
          position: "relative",
          height: "100px",
          width: "100%",
          color: "#FFAD00",
          backgroundColor: "black",
          resize: "none",
          borderColor: "#FFAD00",
        }}
        onInput={handleInput}
        onKeyDown={(e) => {
          if (e.key === "Tab" || e.key === "Enter") {
            e.preventDefault();
            applySuggestion();
          }
        }}
        suppressContentEditableWarning={true}
      >
        {disabled && <span>{text}</span>}
      </div>

      {suggestion && !disabled && (
        <span
          style={{
            position: "absolute",
            top: `${cursorPosition.top - 0.5}px`,
            left: `${cursorPosition.left}px`,
            backgroundColor: "transparent",
            padding: "0 1px",
            fontSize: "15px",
            color: "#555",
            cursor: "pointer",
          }}
          onClick={applySuggestion}
        >
          {suggestion}
        </span>
      )}
    </div>
  );
};

export default AutoSuggestionInput;